<template>
<div class="container-fluid"> 
  <div class="row bookmark-box">
    <bookmark :ids='stepIds'></bookmark>
  </div>

  <div id='mapa' v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <div class="row box height-map">
     <div class="col-lg-12 col-sm-12" >
      <mapChartOnline id="'map'"></mapChartOnline>
    </div>
  </div>

   <!-- GRÁFICO DE TAXA DE FALHA -->
  <div class="row box box-container " >
    <div class="col-lg-12 col-sm-12 box-divided" >
      <ChartFailure></ChartFailure>
    </div>
  </div>

  <!-- GRÁFICO DE TAXA DE FALHA POR PARETO (ANUAL ACUMULADO/MENSAL) 
  <div class="row box box-container " >
    <div class="col-lg-12 col-sm-12 box-divided" >
      <ChartFailurePareto :online='true'></ChartFailurePareto>
    </div>
  </div>
  -->

  <div id='collectOn' v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <div class="row box">
    <div class="col-lg-12 col-md-12">        
        <HeatMap ></HeatMap>
    </div>   
  </div>
  <!-- <br/> -->
  <div class="row box">
    <div class="col-lg-6 col-md-6">        
        <HeatMapSensor></HeatMapSensor>
    </div>
    <div class="col-lg-6 col-md-6">        
        <HeatMapSensorAppointments></HeatMapSensorAppointments>
    </div>
  </div>
  <!-- <br/> -->
  <div class="row box">
    <div class="col-lg-6 col-sm-12 height-box">
      <!--SENSOR STATUS-->
      <ChartsSensorStatus></ChartsSensorStatus>  
    </div>
    <div class="col-lg-6 col-sm-12 height-box">
      <!--NODES STATUS-->
      <ChartsNodesStatus></ChartsNodesStatus>
    </div>

    <!--SENSOR BATERRY-->
    <!-- <div class="col-lg-6 col-sm-12 height-box">
      <ChartsSensorBattery></ChartsSensorBattery>
    </div> -->

  </div>
  <div id='collect' v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <div class="row box">
    <div class="col-lg-6 col-sm-12 height-box">
      <!--COMPONENT STATUS-->
      <chartsStatus ></chartsStatus>
    </div>
    <!--<div class="col-lg-4 col-sm-12 height-box">
      POINT STATUS
      <ChartsPointStatus></ChartsPointStatus>  
    </div>
    -->
    <div class='col-lg-6 col-sm-12 height-box'>
      <!--PRIORITIES CHART-->
      <PrioritiesChart></PrioritiesChart>
    </div>
  </div>
  <div id='defectsOn' v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <div class="row box">
    <div class='col-lg-12 col-sm-12 height-box'>
      <!--DEFECTS CHART-->
      <ChartsDefects ></ChartsDefects>
    </div>
  </div>

  <br/>
  <!-- Recurrence Rate -->
  <div class="row box">
    <div class="col-lg-12 col-sm-12">

      <transition name="show-from-left">
          <Popover name="repetitionOn" :width="240">
              <Help :titleChart="'Recurrence Rate of Interventions'">
                <div slot="content">
                  <p>{{ $t("40") }}</p>
                </div>
            </Help>
          </Popover>
      </transition>

      <div class="title-charts title-bt-help title-margin">{{ $t("41") }}
        <button class="bt-help" v-popover:repetitionOn.right><i class="icon-help ti-help-alt"></i></button>
      </div>

      <!-- Reincidencia Indicator -->
      <div class="col-lg-5ths col-md-5ths col-sm-12" v-for="(item, key, index) in repetition_data" :key="index" style='margin-top: 30px !important'>
        <ReincidenciaIndicator :title="key" :content="item[0]" :perc="item[1]"></ReincidenciaIndicator>
      </div>
      <br/>

      <div class="row box-container">
        <div class="col-lg-12 col-sm-12 box-divided" >
          <ChartReincidenciaPareto :online='true'></ChartReincidenciaPareto>
        </div>
      </div>

      <!-- Reincidencia Chart -->
      <div class="col-lg-4 col-md-4 col-sm-12" v-for="item in repetition_chart_data" :key="item.id">
        <ReincidenciaChart :title="item.title" :data="item.data" :plant="item.plant"></ReincidenciaChart>
      </div>

    </div>
  </div>

  <div id='planning' v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <!--Planning-->
  <div class="row box">
    <div class="col-lg-12 col-sm-12">
      <!--Planning-->
      <chartsReport ></chartsReport>
      <br/>
      <div class="row" style='margin-top: 30px !important'>
          <div class="col-lg-2 col-sm-12" v-for="(item, key, index) in planned_rdps_data" :key="index" style='padding: 10px;'>
              <Donut :id="String(item.id)" :title="item.name" :pendente="item.pendente" :programado="item.programado" :filters="filterGrid" :online="1"></Donut>
          </div>
      </div>
      <div class="row box-container">
        <div class="col-lg-12 col-sm-12 box-divided" >
          <ChartBacklog :online='true'></ChartBacklog>
        </div>
      </div>
    </div>   
  </div>

  <div id='execution' v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <!-- Report Execution Deadline -->
  <div class="row box" >
    <div class="col-lg-12 col-sm-12">

      <transition name="show-from-left">
          <Popover name="execution_deadline" :width="240">
              <Help :titleChart="'Execution'">
                <div slot="content">
                  <p>{{ $t("42") }}</p>
                </div>
            </Help>
          </Popover>
      </transition>

      <div class="title-charts title-bt-help title-margin">{{ $t("43") }}
        <button class="bt-help" v-popover:execution_deadline.right><i class="icon-help ti-help-alt"></i></button>
      </div>

      <br/>
      <br/>

      <div class="row">

        <div class="col-lg-6 col-sm-12">

          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <ReincidenciaIndicator :delay="0" title="On Time" :content="reports_execution_deadline.total[0]" color="#90ed7d" font='24px'></ReincidenciaIndicator>
            </div>
            <div class="col-lg-6 col-sm-12">
              <ReincidenciaIndicator :delay="1" title="1 to 15 days late" :content="reports_execution_deadline.total[1]" color="#f0893a" font='24px'></ReincidenciaIndicator>
            </div>
          </div>

          <br>

          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <ReincidenciaIndicator :delay="2" title="15 to 30 days late" :content="reports_execution_deadline.total[2]" color="#f45b5b" font='24px'></ReincidenciaIndicator>
            </div>
            <div class="col-lg-6 col-sm-12">
              <ReincidenciaIndicator :delay="3" title="> 30 days late" :content="reports_execution_deadline.total[3]" color="#f45b5b" font='24px'></ReincidenciaIndicator>
            </div>
          </div>

        </div>

        <!-- Donut Execution -->
        <div class="col-lg-6 col-sm-12">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <DonutExecution 
                title="" 
                :data="[reports_execution_deadline.total_concluido, reports_execution_deadline.total_atrasado]"
                :filters="filterGrid"
                :online="1"
              >
              </DonutExecution>
            </div>
          </div>
        </div>

      </div>

      <br/>
      <br/>
      <transition name="show-from-left">
          <Popover name="execution_deadline_total" :width="240">
              <Help :titleChart="'Comparison Charts - On time | late'">
                <div slot="content">
                  <p>{{ $t("44") }}</p>
                </div>
            </Help>
          </Popover>
      </transition>

      <div class="title-charts">{{ $t("45") }}
        <button class="bt-help" v-popover:execution_deadline_total.right><i class="icon-help ti-help-alt"></i></button>
      </div>

      <!-- Execution Chart Total -->
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12" v-for="(item, index) in reports_execution_deadline.details_total" :key="index">
          <ExecutionChartTotal :title="item.name" :data="[item['onTime'], item['late']]" :id="String(item.id)" :filters="filterGrid" :online="1"></ExecutionChartTotal>
        </div>
      </div>

      <br/>
      <br/>
      <div class="title-charts">{{ $t("46") }}
        <button class="bt-help" v-popover:execution_deadline_details.right><i class="icon-help ti-help-alt"></i></button>
        <transition name="show-from-left">
            <Popover name="execution_deadline_details" :width="240">
                <Help :titleChart="'Comparison Charts by Period'">
                  <div slot="content">
                    <p>{{ $t("47") }}</p>
                  </div>
              </Help>
            </Popover>
        </transition>
      </div>

      <!-- Execution Chart -->
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12" v-for="(item, index) in reports_execution_deadline.details" :key="index">
          <ExecutionChart :title="item.name" :data="[item[0], item[1], item[2], item[3]]" :id="String(item.id)" :filters="filterGrid" :online="1"></ExecutionChart>
        </div>
      </div>

    </div>
  </div>

  <br/>
  <div class="row box">
    <!--Execution-->
    <div class="col-lg-12 col-sm-12">
        <ExecutionIndicators></ExecutionIndicators>
    </div>   
  </div>
  <br/>
</div>
</template>

<script>
import Vue from 'vue';

import {Chart} from 'highcharts-vue'
import mapChartOnline from 'src/components/Dashboard/Views/Maps/MapChartOnline'
import chartsStatus from 'src/components/Dashboard/Views/ChartsOnline/ChartsStatus'
import ChartsPointStatus from 'src/components/Dashboard/Views/ChartsOnline/ChartsPointStatus'
import ChartsAlarme from 'src/components/Dashboard/Views/ChartsOnline/ChartsAlarme'
import ChartsSensorStatus from 'src/components/Dashboard/Views/ChartsOnline/ChartsSensorStatus'
import ChartsNodesStatus from 'src/components/Dashboard/Views/ChartsOnline/ChartsNodesStatus'
import ChartsSensorBattery from 'src/components/Dashboard/Views/ChartsOnline/ChartsSensorBattery'
import HeatMap from 'src/components/Dashboard/Views/ChartsOnline/HeatMap'
import HeatMapSensor from 'src/components/Dashboard/Views/ChartsOnline/HeatMapSensor'
import HeatMapSensorAppointments from 'src/components/Dashboard/Views/ChartsOnline/HeatMapSensorAppointments'
import PrioritiesChart from 'src/components/Dashboard/Views/ChartsOnline/PrioritiesChart'
import ChartsDefects from 'src/components/Dashboard/Views/ChartsOnline/ChartsDefects'
import bookmark from 'src/components/Dashboard/Views/Components/Bookmark'
import ExecutionIndicators from 'src/components/Dashboard/Views/ChartsOnline/ExecutionIndicators'
import Donut from 'src/components/Dashboard/Views/Charts/Donut'
import ReincidenciaIndicator from 'src/components/Dashboard/Views/Components/ReincidenciaIndicator'
import ReincidenciaChart from 'src/components/Dashboard/Views/Charts/ReincidenciaChart'
import Help from 'src/components/Dashboard/Views/components/Help'
import ExecutionChart from 'src/components/Dashboard/Views/Charts/ExecutionChart'
import DonutExecution from 'src/components/Dashboard/Views/Charts/DonutExecution'
import ExecutionChartTotal from 'src/components/Dashboard/Views/Charts/ExecutionChartTotal'
import chartsReport from 'src/components/Dashboard/Views/ChartsOnline/chartsReport'
import ChartFailure from 'src/components/Dashboard/Views/ChartsOnline/ChartFailureOnline'
import ChartBacklog from 'src/components/Dashboard/Views/Charts/ChartBacklog'
import ChartReincidenciaPareto from 'src/components/Dashboard/Views/Charts/ChartReincidenciaPareto'
import ChartFailurePareto from 'src/components/Dashboard/Views/Charts/ChartFailurePareto'

import axios from 'axios'

import Popover  from 'vue-js-popover'
Vue.use(Popover)

import { mapGetters, mapMutations } from 'vuex';

import mixin from '../../../../utils/mixin';

export default {
  name: 'app',
  options: null,
  components: {
    highcharts: Chart,
    mapChartOnline: mapChartOnline,
    chartsStatus: chartsStatus,
    ChartsPointStatus: ChartsPointStatus,
    ChartsAlarme: ChartsAlarme,
    ChartsSensorStatus: ChartsSensorStatus,
    ChartsNodesStatus: ChartsNodesStatus,
    ChartsSensorBattery: ChartsSensorBattery,
    HeatMap: HeatMap,
    HeatMapSensor: HeatMapSensor,
    HeatMapSensorAppointments: HeatMapSensorAppointments,
    PrioritiesChart: PrioritiesChart,
    ChartsDefects: ChartsDefects,
    bookmark: bookmark,
    ExecutionIndicators: ExecutionIndicators,
    Donut,
    ReincidenciaIndicator,
    ReincidenciaChart,
    Help,
    popover: Popover,
    ExecutionChart,
    DonutExecution,
    ExecutionChartTotal,
    chartsReport,
    ChartFailure,
    ChartBacklog,
    ChartReincidenciaPareto,
    ChartFailurePareto,
  },
  data () {
    return {
      stepIds: ['collectOn', 'result', 'defectsOn', '', 'planning', 'execution', 'mapa'],
      menutop: false,
      planned_rdps_data: [],
      repetition_data: {},
      repetition_chart_data: [],
      reports_execution_deadline: {
        total: {},
        details: [],
        total_atrasado: 0,
        total_concluido: 0,
        details_total: []
      }
    }
  },
  mixins: [mixin],
  mounted: function () {
    this.changeTab('online');
  },
  computed: {
    filterGrid: function() {
      // propriedades iguais ao offline para o ser usado no Donut
      let res = {
        'plant': this.filtersOn.planta,
        'area': this.filtersOn.area_f,
        'sector': this.filtersOn.sector_f,
        'component': this.filtersOn.subset,
        'plant_name': this.filtersOn.planta_name,
        ...this.filtersOn
      }

      return res
    },
    ...mapGetters(['menu', 'filtersOn']),
  },
  watch: {
    menu: function(newValue){
      //console.log('scroll', this.menu.book)
      if(this.menu.book > 30){ 
        this.menutop = true
      }
      if(this.menu.book < 29){ 
        this.menutop = false
      }
    },
    filtersOn: function(){
      this.get_planned_reports();
      this.get_repetition();
      this.get_executed_reports();
    }
  },
  methods: {
    get_planned_reports: function(){
      const API = process.env.ROOT_API;

      const ENDPOINT = 'v1/mysemeq-ambev/get-planned-reports?online=1'
      let self = this;

      let param = {
        plant: this.filtersOn.planta,
        area: this.filtersOn.area_f,
        sector: this.filtersOn.sector_f,
        machine: this.filtersOn.machine,
        component: this.filtersOn.subset,
        ...this.filtersOn
      }

      self.planned_rdps_data = [];
      axios({method: 'GET', url: API + ENDPOINT, params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        self.planned_rdps_data = resp.data;
      })
      .catch(err => {
        self.ApiErrorHandler(self, error.response.data.status_code);
      })
    },
    get_repetition: function(){
      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-repetition?online=1'
      let self = this;

      let param = {
        plant: this.filtersOn.planta,
        area: this.filtersOn.area_f,
        sector: this.filtersOn.sector_f,
        machine: this.filtersOn.machine,
        component: this.filtersOn.subset,
        ...this.filtersOn
      }

      this.repetition_data = [];
      this.repetition_chart_data = [];
      axios({method: 'GET', url: API + ENDPOINT, params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(res => {
        let repetition = res.data.total;

        let repetition_chart_data = [];
        for(let i in res.data.detail) {
          let dados = res.data.detail[i];

          repetition_chart_data.push({
            id: i,
            title: dados.plant,
            plant: dados.plant_id,
            data: [
              [dados['R1'], dados['R2'], dados['R3'], dados['R3+']],
              [dados['R1_perc'], dados['R2_perc'], dados['R3_perc'], dados['R3+_perc']]
            ]
          });

        }

        self.repetition_chart_data = repetition_chart_data;

        self.repetition_data = {
          'R0': [repetition['R0'], repetition['R0_perc']],
          'R1': [repetition['R1'], repetition['R1_perc']],
          'R2': [repetition['R2'], repetition['R2_perc']],
          'R3': [repetition['R3'], repetition['R3_perc']],
          'R3+': [repetition['R3+'], repetition['R3+_perc']]
        };

      })
      .catch(err => {
        self.ApiErrorHandler(self, error.response.data.status_code);
      })
    },
    get_executed_reports: function() {

      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-executed-reports-deadline?online=1'

      let param = {
        plant: this.filtersOn.planta,
        area: this.filtersOn.area_f,
        sector: this.filtersOn.sector_f,
        machine: this.filtersOn.machine,
        component: this.filtersOn.subset,
        ...this.filtersOn
      }

      this.reports_execution_deadline = {total: {}, details: [], details_total: []};

      let self = this;
      axios({method: 'GET', url: API + ENDPOINT, params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(res => {
        self.reports_execution_deadline = res.data;

        self.reports_execution_deadline.total_atrasado = res.data.total[1] + res.data.total[2] + res.data.total[3];
        self.reports_execution_deadline.total_concluido = res.data.total[0];
      })
      .catch(err => {
        self.ApiErrorHandler(self, error.response.data.status_code);
      })
    },
    ...mapMutations(['changeTab']),
  }
}
</script>
<style scoped>
  .menutop{
    /* padding-top: 25px; */
    position: relative;
    bottom: 35px;
  }
  .height-box{
    height: 430px;    
  }
  .height-box-top{
    height: 490px;
  }

  /* cor de fundo para grupo de gráficos */
  .box {
    background-color: #2a2a2e;
    padding: 15px 0;
  }
  .height-map{
    /*height: 420px;*/
    margin-top: 83px;
  }
  .bookmark-box{
    position: fixed;
    top: 0%;
    left: 23%;
    z-index: 9999999;
    background-color: #000;
    width: 75%;
  }

  div[data-popover="planned_rdps"] {
    left: 55% !important;
    top: 0% !important;
  }

  div[data-popover="repetitionOn"] {
    left: 64% !important;
    top: 0% !important;
  }

  div[data-popover="execution_deadline"] {
    left: 57% !important;
    top: 0% !important;
  }

  div[data-popover="execution_deadline_total"] {
    left: 66% !important;
    top: 382px !important;
  }
  
  div[data-popover="execution_deadline_details"] {
    left: 69% !important;
    top: 0% !important;
  }

  .title-charts {
    text-align: center; 
    position: relative;
    width: 100%;
    left: 0;
  }

  
  @media screen and (max-width: 1200px) {
    .box-container {
      display: block;
    }
    .box-divided:first-child {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }

   @media screen and (max-width: 1175px) {
    .bookmark-box{
      top: 35px;
      width: 72%;
      left: 27%;
    }
    .height-map{
      margin-top: 108px;
    }
  }

  @media screen and (max-width: 992px) {
    .bookmark-box{
      width: 94%;
      left: 5%;
    }
  }

  @media screen and (max-width: 650px) {
    .bookmark-box{
      width: 90%;
      left: 11%;
    }
  }

  @media screen and (max-width: 420px) {
    .bookmark-box{
      width: 80%;
      left: 16%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Online.vue